import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3b200e86"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "GroupLayout"
};
var _hoisted_2 = {
  key: 0,
  class: "logoLink",
  href: "#"
};
var _hoisted_3 = {
  style: {
    "font-size": "20px",
    "line-height": "30px",
    "font-weight": "800"
  }
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  style: {
    "font-size": "20px",
    "line-height": "30px",
    "font-weight": "800"
  }
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_9 = {
  class: "logoLink"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  key: 1,
  class: "logoLink"
};
var _hoisted_13 = {
  style: {
    "font-size": "20px",
    "font-weight": "800"
  }
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "color": "#e40006",
      "font-size": "16px",
      "font-weight": "800"
    }
  }, "待更新", -1);
});

var _hoisted_16 = {
  class: "GHOperator"
};
var _hoisted_17 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = _resolveComponent("el-tooltip");

  var _component_GHSeparator = _resolveComponent("GHSeparator");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
    class: "SubGroupLayout",
    style: _normalizeStyle({
      'height': "".concat($props.rows * 40, "px"),
      'grid-template-rows': "repeat(".concat($props.rows, ",40px)")
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredGroup, function (comp, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [comp.is_enable && comp.rhino_versions.indexOf(_ctx.current_rhino_version) !== -1 ? (_openBlock(), _createElementBlock("a", _hoisted_2, [_ctx.current_tag === '全部' || comp.tags.includes(_ctx.current_tag) || _ctx.current_tag === '近期更新' && comp.is_recent_updated ? (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 0,
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(function () {
        return [_createElementVNode("span", _hoisted_3, [_createElementVNode("b", null, _toDisplayString(comp.name), 1), _hoisted_4, _createTextVNode(_toDisplayString(comp.sub_name), 1)])];
      }),
      default: _withCtx(function () {
        return [_createElementVNode("div", {
          class: _normalizeClass(['GHOperator', {
            shake: $data.flashingIconId === comp.id
          }]),
          onClick: _withModifiers(function ($event) {
            return $options.onClickComp(comp.id);
          }, ["stop"])
        }, [_createElementVNode("img", {
          class: "ghiconenable",
          src: comp.icon
        }, null, 8, _hoisted_6)], 10, _hoisted_5)];
      }),
      _: 2
    }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 1,
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(function () {
        return [_createElementVNode("span", _hoisted_7, [_createElementVNode("b", null, _toDisplayString(comp.name), 1), _hoisted_8, _createTextVNode(_toDisplayString(comp.sub_name), 1)])];
      }),
      default: _withCtx(function () {
        return [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          class: _normalizeClass(['GHOperator', {
            shake: $data.flashingIconId === comp.id
          }]),
          onClick: _withModifiers(function ($event) {
            return $options.onClickComp(comp.id);
          }, ["stop"])
        }, [_createElementVNode("img", {
          class: "NoNeedToPayAttention",
          src: comp.icon
        }, null, 8, _hoisted_11)], 10, _hoisted_10)])];
      }),
      _: 2
    }, 1024))])) : _createCommentVNode("", true), !comp.is_enable ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_tooltip, {
      placement: "bottom-start",
      effect: "customized",
      "hide-after": 0
    }, {
      content: _withCtx(function () {
        return [_createElementVNode("span", _hoisted_13, [_createElementVNode("b", null, _toDisplayString(comp.name), 1)]), _hoisted_14, _hoisted_15];
      }),
      default: _withCtx(function () {
        return [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
          class: "ghicondisable",
          src: comp.icon
        }, null, 8, _hoisted_17)])];
      }),
      _: 2
    }, 1024)])) : _createCommentVNode("", true)]);
  }), 128))], 4), [[_vShow, $options.hasVisibleIcons]]), _withDirectives(_createVNode(_component_GHSeparator, {
    id: "Sep"
  }, null, 512), [[_vShow, $options.hasVisibleIcons]])]);
}